import { render, staticRenderFns } from "./TeacherAssignment.vue?vue&type=template&id=49e6c412"
import script from "./TeacherAssignment.vue?vue&type=script&lang=js"
export * from "./TeacherAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports